import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { zAppDevTabViewComponent } from './tabView.component';
import { ZAppDevTabPanel } from './tabPanel.component';

const COMPONENTS = [
  zAppDevTabViewComponent,
  ZAppDevTabPanel
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule
  ],
  exports: [...COMPONENTS]
})
export class zAppDevTabContainerModule { }
